module.exports = __webpack_public_path__ + "static/media/berserk_axe.6e8d6bcb.png";